const promoColumns = [
  {
    key: 'num',
    label: 'SN.',
  },
  {
    key: 'name',
    label: 'Code',
  },
  {
    key: 'limit',
    label: 'Usage Left',
  },
  {
    key: 'currentUsage',
    label: 'Current Usage',
  },
  {
    key: 'isActive',
    label: 'Active',
  },

  {
    key: 'actions',
    label: 'Actions',
  },
];

export { promoColumns };
